import './RegisterPage.css';
import React, { useState } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
var axios = require("axios");

const RegisterPage = () => {
    const history = useHistory();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [phone, setPhone] = useState('');
    const [name, setName] = useState('');
    const [designation, setDesignation] = useState('');
    const [isValidMobile, setIsValidMobile] = useState(true);
    const [isValid, setIsValid] = useState(true);

    const handleSubmit = () => {
        const regex = /^\d{10}$/;
        const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (regex.test(phone)) {
            setIsValidMobile(true);
            if (regexEmail.test(email)) {
                setIsValid(true);
                if(password && name && designation){
                    var fdata = new FormData();
                    fdata.append("username", email);
                    fdata.append("password", password);
                    fdata.append("name", name);
                    fdata.append("phone", phone);
                    fdata.append("email", email);
                    fdata.append("designation", designation);
                      axios({
                        method: "post",
                        url: 'http://112.133.197.42/API/resgisterPage.php',
                        data: fdata,
                        headers: { "Content-Type": "multipart/form-data" },
                      })
                        .then(function (response) {
                            toast.success('Registration Succesfull !', { position: toast.POSITION.TOP_RIGHT });
                            history.push('/');
                        })
                        .catch(function (response) {
                     });
                }
                else{
                    toast.error('Some Field are missing !', { position: toast.POSITION.TOP_RIGHT });
                    //alert("Some Field are missing")
                }

            } else {

                setIsValid(false);
            }
        } else {
            setIsValidMobile(false);
            if (regex.test(email)) {
                setIsValid(true);
                
            } else {

                setIsValid(false);
            }
            
        }
    //   var fdata = new FormData();
    //   fdata.append("username", email);
    //   fdata.append("password", password);
    //   axios({
    //     method: "post",
    //     url: 'http://localhost/silks/login.php',
    //     data: fdata,
    //     headers: { "Content-Type": "multipart/form-data" },
    //   })
    //     .then(function (response) {
    //       console.log(response)
    //       if(response){
    //         localStorage.setItem('token', response.data.token);
    //         window.location.reload(); 
    //       }
          
    //     })
    //     .catch(function (response) {
    //  });
    };
  return (
    <div className="container">
      <ToastContainer />
      <h1>Register</h1>
        <div className="form-group">
          <label htmlFor="username">Name</label>
          <input type="text" id="name" name="name" placeholder="Enter your name" required 
           onChange={(event) => setName(event.target.value)}
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input type="email" id="email" name="email" placeholder="Enter your email" required 
           onChange={(event) => setEmail(event.target.value)}
          />
          {!isValid && <p>Please enter a valid email address.</p>}
        </div>
        <div className="form-group">
          <label htmlFor="password">Phone</label>
          <input type="number" id="password" name="password" placeholder="Enter your Phone" required 
          onChange={(event) => setPhone(event.target.value)}
          />
          {!isValidMobile && <p>Please enter a valid 10-digit mobile number.</p>}
        </div>
        <div className="form-group">
          <label htmlFor="username">Designation</label>
          <input type="text" id="designation" name="designation" placeholder="Enter your Designation" required 
           onChange={(event) => setDesignation(event.target.value)}
          />
        </div>
        <div className="form-group">
          <label htmlFor="confirm-password"> Password</label>
          <input
            type="password"
            id="password"
            name="password"
            placeholder="Enter your password"
            onChange={(event) => setPassword(event.target.value)}
            required
          />
        </div>
        <button type="submit" onClick={()=>{handleSubmit()}}>Register</button>
    </div>
  );
};

export default RegisterPage;
